import { render, staticRenderFns } from "./CrewActivity.vue?vue&type=template&id=37c67c16&scoped=true&"
import script from "./CrewActivity.vue?vue&type=script&lang=js&"
export * from "./CrewActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c67c16",
  null
  
)

export default component.exports